import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./header.scss";
import $ from "jquery";
import TextConstants from "../../../TextConstants";
import AiCreatorCTA from "./aiCreatorCTA";
import { deviceType } from "../../../Utilities";
import { CALENDLY_LINK, PORTAL_BASE_URL, REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from "../../../env";
import posthog from "posthog-js";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";

class DarkNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            navBarClass: "",
        };
    }

    render() {
        const { items } = TextConstants.NAVBAR;
        return (
            <div className="custom-nav" id="topheader">
                <AiCreatorCTA />
                <nav className={`navbar dark ${deviceType() == 'mobile' ? `nav-bar-mobile-width` : ``} navbar-expand-lg navbar-darkk pt-2 justify-space-between navbar-border-bottom`}>
                    <Link className="navbar-brand" to={"/"}>
                        <img src="/featured/Logo.png" className="dark-nav-logo" alt="ALL3D" />
                    </Link>
                    <button
                        className="navbar-toggler collapsed dark-navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span class="my-1 mx-2 close">
                            <CloseOutlined />
                        </span>
                        <span className="navbar-toggler-icon">
                            <MenuOutlined />
                        </span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto"></ul>
                        <ul className="navbar-nav">
                            <li className={`links nav-item m-auto text-settings`}>
                                <NavLink
                                    className="nav-link header-text manrope f-14 w-700 lh-22 blue-gradient"
                                    style={{ lineHeight: "0", paddingTop: 0, paddingBottom: 0 }}
                                    activeClassName="active"
                                    to="/ai-creator"
                                >
                                    <img src="/ai_creator/ai-creator-twinkle.svg" />  {items[0]}

                                </NavLink>
                            </li>
                            <li className={`links nav-item m-auto text-settings`}>
                                <NavLink
                                    className="nav-link header-text manrope f-14 w-700 lh-22 white"
                                    style={{ lineHeight: "0" }}
                                    activeClassName="active"
                                    to="/pricing"
                                >
                                    {items[1]}
                                </NavLink>
                            </li>
                            <li className={`links nav-item m-auto text-settings`}>
                                <NavLink
                                    className="nav-link header-text manrope f-14 w-700 lh-22 white"
                                    style={{ lineHeight: "0" }}
                                    activeClassName="active"
                                    to="/blog"
                                >
                                    {items[2]}
                                </NavLink>
                            </li>

                            <li className={`links nav-item m-auto text-settings`}>
                                <NavLink
                                    className="nav-link header-text manrope f-14 w-700 lh-22 white"
                                    style={{ lineHeight: "0" }}
                                    activeClassName="active"
                                    to="/about-us"
                                >
                                    {items[4]}
                                </NavLink>
                            </li>
                            <li
                                className={`links nav-item m-auto text-settings  display-button-small`}
                                style={{ borderBottom: "none" }}
                            >
                                <button
                                    onClick={() => {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const email = urlParams.get('email') || "";
                                        const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                                            api_host: POSTHOG_API_HOST,
                                            autocapture: false,
                                            name: "register",
                                            capture_pageview: false,
                                            loaded: (ph) => {
                                                if (utm_source) ph.register({ utm_source: utm_source });
                                            },
                                        });
                                        if (ph) {
                                            ph.capture('login_click', {
                                                location: window.location.pathname,
                                                button: 'login',
                                                utm_source: utm_source,
                                                email: email
                                            });
                                        }
                                        window.location.href = PORTAL_BASE_URL
                                    }}
                                    id="getStart"
                                    className={`btn login-btn-transparent dark manrope f-14 w-700 lh-22 mr-8 white`}
                                    disabled={false}
                                >
                                    {items[5]}
                                </button>
                                <button
                                    onClick={() => {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const email = urlParams.get('email') || "";
                                        const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                                            api_host: POSTHOG_API_HOST,
                                            autocapture: false,
                                            name: "register",
                                            capture_pageview: false,
                                            loaded: (ph) => {
                                                if (utm_source) ph.register({ utm_source: utm_source });
                                            },
                                        });
                                        if (ph) {
                                            ph.capture('schedule_demo_click', {
                                                location: window.location.pathname,
                                                button: 'schedule_a_demo',
                                                utm_source: utm_source,
                                                email: email
                                            });
                                        }
                                        window.open(CALENDLY_LINK, "_blank")
                                    }}
                                    id="getStart"
                                    className={`btn transparent-btn manrope f-14 lh-22 w-700 white`}
                                    disabled={false}
                                >
                                    {items[6]}
                                </button>
                            </li>

                        </ul>
                    </div>

                    <div className="collapse navbar-collapse display-button-large">
                        <ul className="navbar-nav">
                            <li
                                className={`links nav-item m-auto text-settings`}
                                style={{ borderBottom: "none" }}
                            >
                                <button
                                    onClick={() => {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const email = urlParams.get('email') || "";
                                        const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                                            api_host: POSTHOG_API_HOST,
                                            autocapture: false,
                                            name: "register",
                                            capture_pageview: false,
                                            loaded: (ph) => {
                                                if (utm_source) ph.register({ utm_source: utm_source });
                                            },
                                        });
                                        if (ph) {
                                            ph.capture('login_click', {
                                                location: window.location.pathname,
                                                button: 'login',
                                                utm_source: utm_source,
                                                email: email
                                            });
                                        }
                                        window.location.href = PORTAL_BASE_URL
                                    }}
                                    id="getStart"
                                    className={`btn login-btn-transparent dark manrope f-14 w-700 lh-22 mr-8 white`}
                                    disabled={false}
                                >
                                    {items[5]}
                                </button>
                                <button
                                    onClick={() => {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const email = urlParams.get('email') || "";
                                        const utm_source = localStorage.getItem('utm_source') || urlParams.get('utm_source');
                                        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
                                            api_host: POSTHOG_API_HOST,
                                            autocapture: false,
                                            name: "register",
                                            capture_pageview: false,
                                            loaded: (ph) => {
                                                if (utm_source) ph.register({ utm_source: utm_source });
                                            },
                                        });
                                        if (ph) {
                                            ph.capture('schedule_demo_click', {
                                                location: window.location.pathname,
                                                button: 'schedule_a_demo',
                                                utm_source: utm_source,
                                                email: email
                                            });
                                        }
                                        window.open(CALENDLY_LINK, "_blank")
                                    }}
                                    id="getStart"
                                    className={`btn transparent-btn manrope f-14 lh-22 w-700 white`}
                                    disabled={false}
                                >
                                    {items[6]}
                                </button>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
}

export default DarkNavbar;
